// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AssinarController from "./assinar_controller"
application.register("assinar", AssinarController)

import ChangeTabsController from "./change_tabs_controller"
application.register("change-tabs", ChangeTabsController)

import ChartMateriasController from "./chart_materias_controller"
application.register("chart-materias", ChartMateriasController)

import CheckAllController from "./check_all_controller"
application.register("check-all", CheckAllController)

import CheckCountController from "./check_count_controller"
application.register("check-count", CheckCountController)

import CurrencyController from "./currency_controller"
application.register("currency", CurrencyController)

import Edicao__RemoveMateriaController from "./edicao/remove_materia_controller"
application.register("edicao--remove-materia", Edicao__RemoveMateriaController)

import FiltraAssuntosController from "./filtra_assuntos_controller"
application.register("filtra-assuntos", FiltraAssuntosController)

import MaskController from "./mask_controller"
application.register("mask", MaskController)

import Materia__ArquivoController from "./materia/arquivo_controller"
application.register("materia--arquivo", Materia__ArquivoController)

import Modal__CloseController from "./modal/close_controller"
application.register("modal--close", Modal__CloseController)

import Modal__ShowController from "./modal/show_controller"
application.register("modal--show", Modal__ShowController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import SelectAutorController from "./select_autor_controller"
application.register("select-autor", SelectAutorController)

import SiglasController from "./siglas_controller"
application.register("siglas", SiglasController)

import TaggingsController from "./taggings_controller"
application.register("taggings", TaggingsController)

import TogglerController from "./toggler_controller"
application.register("toggler", TogglerController)

import TtipController from "./ttip_controller"
application.register("ttip", TtipController)

import UpdateAssuntosController from "./update_assuntos_controller"
application.register("update-assuntos", UpdateAssuntosController)

import UploaderController from "./uploader_controller"
application.register("uploader", UploaderController)
